export default __webpack_public_path__ + "static/media/il.3c6c3d4a.svg";